import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScanSplit } from '@devinforius/super-compos-17';
import { Observable } from 'rxjs';
import { Scan } from 'src/app/shared/models/iScanV1/scan';
import { UploadScan } from 'src/app/shared/models/iScanV1/upload-scan';

@Injectable({
  providedIn: 'root',
})
export class IScanServices {
  public iscanBaseUrl: string;
  public body: FormData;
  public headers: HttpHeaders; //  = new HttpHeaders();
  public params: HttpParams = new HttpParams();

  constructor(public http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.iscanBaseUrl = config.iScanUrl + '/api/v1';
    this.body = new FormData();
    this.params = new HttpParams();
  }

  getIscanData(fileGuid: string): Observable<Scan> {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.get<Scan>(
      `${this.iscanBaseUrl}/files/${fileGuid}/data`,
      {
        headers: this.headers,
      }
    );
  }

  upload(event: { file: File[], splitMode: string , callback: string}): Observable<UploadScan> {
    const formData = new FormData();
    event.file.forEach((file) => {
      formData.append(`file`, file);
    });
    formData.append('splitMode', event.splitMode);
    formData.append('callback', event.callback);
    return this.http.post<UploadScan>(`${this.iscanBaseUrl}/files/upload`, formData);
  }

  getBlob(fileGuid: string, pageGuid: string): Observable<Blob> {
    return this.http.get<Blob>(
      `${this.iscanBaseUrl}/files/${fileGuid}/pages/${pageGuid}/image`,
      {
        responseType: 'blob' as 'json'
      }
    );
  }

  downloadSplit(fileGuid: string, splitGuid: string): Observable<any> {
    return this.http.get<Blob>(
      `${this.iscanBaseUrl}/files/${fileGuid}/splits/${splitGuid}/pdf`, 
      { responseType: 'blob' as 'json' }
    );
  }
  
  downloadFile(fileGuid: string): Observable<any> {
    return this.http.get<Blob>(
      `${this.iscanBaseUrl}/files/${fileGuid}`, 
      { responseType: 'blob' as 'json' }
    );
  }

  saveSplit(fileGuid: string, split: ScanSplit[]): Observable<any> {
    return this.http.put<any>(
      `${this.iscanBaseUrl}/files/${fileGuid}/data`,
      split
    );
  }

  deleteFile(fileGuid: string): Observable<any> {
    return this.http.delete<any>(
      `${this.iscanBaseUrl}/files/${fileGuid}`,
    );
  }

  getStatus(fileGuid: string): Observable<any> {
    return this.http.get<any>(
      `${this.iscanBaseUrl}/files/${fileGuid}/status`,
    );
  }
}
